/* ============================================================
   Kit Builder — página "Monte seu Kit" (v2 do desconto-progressivo-1)
   - <kit-product-card>: resolve variante a partir dos <select>s sempre
     visíveis (lógica portada de dp-quick-buy.js) e adiciona ao carrinho
     real via /cart/add.js, marcando a linha com a property `_dp_source`.
   - <kit-builder-sidebar>: lê o carrinho real via /cart.js (plumbing
     portada de desconto-progressivo.js — sem polling, reage a eventos),
     filtra pela mesma property e renderiza contador/lista/subtotal/
     total no Pix/economia. O desconto por faixa em si é 100% o que a
     Faixa Automática (moonapps) já aplicou no carrinho — só a camada de
     Pix é calculada aqui, igual o resto do tema já faz.
   ============================================================ */
(function () {
  function brl(cents) {
    return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  /* Pix é a mesma conta em todo lugar da página (card, popup e sidebar) e
     é o preço que o resto da loja mostra como principal — ver
     snippets/price.liquid: <s>valor cheio</s> <b>valor no Pix</b> no pix. */
  function kbPixPct() {
    return parseFloat(window.KB_PIX_DISCOUNT || 0) || 0;
  }
  function kbPixMultiplier() {
    var pct = kbPixPct();
    return pct > 0 ? (100 - pct) / 100 : 1;
  }
  function kbPixCents(cents) {
    return Math.round((cents || 0) * kbPixMultiplier());
  }
  /* "16%", "2,5%" — sem casa decimal à toa e com vírgula, como o resto da loja. */
  function pctLabel(n) {
    return String(Math.round(n * 100) / 100).replace('.', ',') + '%';
  }

  /* Valor CHEIO de exibição: o riscado é o compare_at quando o produto
     está em promoção, senão o próprio preço. Nunca menor que o preço. */
  function kbFullCents(price, compareAt) {
    return Math.max(compareAt || 0, price || 0);
  }

  /* % do desconto que a Shopify aplicou NESTA linha do carrinho. Prefere o
     valor que vem na alocação (`value: "16.0"` — é o que o checkout cobra) e
     só cai pra conta quando a alocação é em valor fixo, caso de fronteira do
     combo. Zero quando a linha não recebeu desconto nenhum. */
  function linePercentOff(item, originalCents, finalCents) {
    var allocs = item.line_level_discount_allocations || [];
    for (var i = 0; i < allocs.length; i++) {
      var app = allocs[i].discount_application || {};
      var value = parseFloat(app.value);
      if (app.value_type === 'percentage' && value > 0) return value;
    }
    if (originalCents > 0 && finalCents < originalCents) {
      return ((originalCents - finalCents) / originalCents) * 100;
    }
    return 0;
  }

  /* Preço da linha com a faixa aplicada, arredondando como a Shopify faz:
     por UNIDADE, e só então multiplicando. Conferido no carrinho real —
     3x R$ 169,90 a 16% dá R$ 428,16, não R$ 428,15. */
  function precoComFaixa(originalCents, qty, pct) {
    if (!(pct > 0) || qty <= 0) return originalCents;
    return Math.round((originalCents / qty) * (100 - pct) / 100) * qty;
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(null, args); }, wait);
    };
  }

  /* Resolução de variante/estoque — compartilhada entre <kit-product-card>
     e <kit-quick-view> (o popup usa o MESMO JSON de produto do card, só
     numa UI maior). */
  function matchVariant(product, selected) {
    return (product.variants || []).find(function (v) {
      return selected.every(function (val, i) { return v.options[i] === val; });
    }) || null;
  }

  function valueHasStock(product, selected, i, val) {
    return (product.variants || []).some(function (v) {
      if (v.options[i] !== val || !v.available) return false;
      return v.options.every(function (optVal, j) {
        if (j === i || selected[j] === undefined) return true;
        return optVal === selected[j];
      });
    });
  }

  /* Sem variante exata pra combinação selecionada (ex.: cor esgotada nesse
     tamanho) — acha a variante que mais bate com o que está selecionado,
     só pra exibir foto/preço. Não habilita compra. */
  function bestDisplayVariant(product, selected) {
    var best = null;
    var bestScore = -1;
    (product.variants || []).forEach(function (variant) {
      var score = variant.options.reduce(function (acc, val, i) {
        return acc + (selected[i] !== undefined && val === selected[i] ? 1 : 0);
      }, 0);
      if (score > bestScore) { bestScore = score; best = variant; }
    });
    return best;
  }

  /* Avisa o carrinho NATIVO do site (ícone + drawer) que o carrinho mudou.
     document.dispatchEvent('cart:updated') só é ouvido pela própria sidebar
     do kit-builder — o ícone/drawer do tema escutam é o pubsub
     PUB_SUB_EVENTS.cartUpdate (ver product-form.js/kit-explode.js). O
     CartItems nativo (assets/cart.js, onCartUpdate) reage a isso re-
     buscando as sections do drawer, SEM abrir ele — só sincroniza o que já
     está montado na página. */
  function publishCartUpdate(payload) {
    if (typeof publish === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
      publish(PUB_SUB_EVENTS.cartUpdate, payload);
    }
  }

  /* O #cart-icon-bubble mora em sections/header.liquid — uma section
     DIFERENTE de cart-drawer. O onCartUpdate() nativo (assets/cart.js) só
     rebusca a section cart-drawer, então o ícone nunca era atualizado por
     ele. Busca a section header direto (mesmo padrão de
     cart-drawer-custom.js pra #CartDrawer-Progress) e troca só o ícone. */
  function refreshCartIconBubble() {
    fetch('/?section_id=header')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var target = document.querySelector('#cart-icon-bubble');
        var source = doc.querySelector('#cart-icon-bubble');
        if (target && source) target.innerHTML = source.innerHTML;
      })
      .catch(function () {});
  }

  function getQuickView() {
    var el = document.querySelector('kit-quick-view');
    if (!el) {
      el = document.createElement('kit-quick-view');
      document.body.appendChild(el);
    }
    return el;
  }

  /* Quanto da tela as barras GRUDADAS NO TOPO estão cobrindo agora.
     `--header-height` (definida em sections/header.liquid) mede só o
     `.section-header`, e no topo dessa loja mora mais coisa: a barra de
     avisos e os contadores são seções próprias, fixas/sticky, ACIMA do
     header (ver a ordem em sections/header-group.json). Usando só
     `--header-height`, o card do kit começava alto demais e ficava POR
     BAIXO da barra de avisos.

     Medimos o fundo real de cada barra que está pinçada no topo neste
     momento — inclusive quando o tema esconde o header no scroll, caso em
     que ela sai da conta e o card sobe pra ocupar o espaço. */
  function topChromeBottom() {
    var fundo = 0;
    var candidatos = document.querySelectorAll(
      '.section-header, .countdown-section, .announcement-bar, #shopify-section-group-header-group > *'
    );
    Array.prototype.forEach.call(candidatos, function (el) {
      var pos = window.getComputedStyle(el).position;
      if (pos !== 'fixed' && pos !== 'sticky') return;
      var r = el.getBoundingClientRect();
      if (r.height <= 0 || r.bottom <= 0) return;
      /* As barras do topo se empilham (avisos, contador, header), então a de
         baixo não começa em 0 — a faixa abaixo cobre a pilha inteira sem
         pegar uma seção sticky qualquer no meio da página. Quem já rolou pra
         fora tem `bottom` negativo e cai no teste acima. */
      if (r.top > 150) return;
      if (r.bottom > fundo) fundo = r.bottom;
    });
    /* Teto de segurança: medida estranha não pode espremer o card a ponto de
       ele sumir. */
    return Math.max(0, Math.min(Math.round(fundo), Math.round(window.innerHeight * 0.4)));
  }

  /* Mesma ideia pro menu inferior do mobile: quanto da tela ele cobre por
     baixo. Medir o retângulo (em vez de ler `style.opacity`, como antes)
     cobre também o caso de o tema escondê-lo por transform — que era o
     jeito de ele reaparecer POR CIMA do rodapé do card. */
  function bottomChromeHeight() {
    var fb = document.querySelector('.footer-bar-mobile');
    if (!fb) return 0;
    var cs = window.getComputedStyle(fb);
    if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return 0;
    var r = fb.getBoundingClientRect();
    if (r.height <= 0) return 0;
    return Math.max(0, Math.round(window.innerHeight - r.top));
  }

  /* Reserva o espaço das duas barras do tema (topo e rodapé) pra sidebar
     fixa nunca ficar por baixo de nenhuma delas. */
  function setFooterBarHeight() {
    var h = bottomChromeHeight();
    /* Sem o menu inferior (h=0), a sidebar fica colada na própria barra
       do navegador (Safari etc.) — soma uma folga extra só nesse caso;
       com o menu presente, o espaço dele já é suficiente e nada muda. */
    var extra = h === 0 ? 16 : 0;
    document.documentElement.style.setProperty('--kb-footerbar-h', (h + extra) + 'px');
    document.documentElement.style.setProperty('--kb-header-h', topChromeBottom() + 'px');
  }

  /* O topo e o rodapé mudam no scroll (o tema esconde e mostra as duas
     barras), então recalcula junto — uma vez por quadro, nunca por evento. */
  var medindo = false;
  function agendarMedida() {
    if (medindo) return;
    medindo = true;
    window.requestAnimationFrame(function () {
      medindo = false;
      setFooterBarHeight();
    });
  }
  window.addEventListener('scroll', agendarMedida, { passive: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setFooterBarHeight);
  } else {
    setFooterBarHeight();
  }
  window.addEventListener('load', setFooterBarHeight);
  window.addEventListener('resize', setFooterBarHeight);

  var footerBarEl = document.querySelector('.footer-bar-mobile');
  if (footerBarEl) {
    /* O menu some por completo (display:none) quando o <body> ganha
       `overflow-hidden` — ex: carrinho aberto (ver cart-drawer.js) —
       isso não dispara load/resize. Um ResizeObserver pega essa
       mudança de tamanho (visível -> 0) na hora. */
    if (window.ResizeObserver) {
      new ResizeObserver(setFooterBarHeight).observe(footerBarEl);
    }
    /* Já o esconder por scroll é via style inline (opacity/transform),
       não muda tamanho — o ResizeObserver não pega. Observa o próprio
       style pra recalcular na hora. */
    new MutationObserver(setFooterBarHeight).observe(footerBarEl, {
      attributes: true,
      attributeFilter: ['style']
    });
  }

  /* ================= <kit-product-card> ================= */
  if (!customElements.get('kit-product-card')) {
    class KitProductCardEl extends HTMLElement {
      connectedCallback() {
        var dataEl = this.querySelector('[data-kit-product]');
        if (!dataEl) return;
        var data;
        try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

        /* Família de cores: uma cor pode ser um produto Shopify separado
           (custom.complementary_products) — a Camiseta Minimal tem 12 cores em
           4 produtos. O card mostra a paleta inteira e clicar numa cor de irmão
           troca o produto ativo por baixo. JSON antigo (sem family) segue
           valendo: vira família de um. */
        this.family = (data.family && data.family.length) ? data.family : [data];
        this.product = this.family[0];

        this.swatchButtons = Array.prototype.slice.call(this.querySelectorAll('.kit-builder-card__swatch'));
        this.selects = Array.prototype.slice.call(this.querySelectorAll('.kit-builder-card__select'));
        this.addBtn = this.querySelector('[data-kit-add]');
        this.addLabel = this.querySelector('[data-kit-add-label]');
        this.errorEl = this.querySelector('[data-kit-error]');
        this.priceNowEl = this.querySelector('[data-kit-price-now]');
        this.priceWasEl = this.querySelector('[data-kit-price-was]');
        this.imageEl = this.querySelector('.kit-builder-card__image');
        this.mediaEl = this.querySelector('.kit-builder-card__media');
        this.titleEl = this.querySelector('.kit-builder-card__title');

        var variants = this.product.variants || [];
        var firstAvailable = variants.find(function (v) { return v.available; }) || variants[0];
        this.selected = firstAvailable ? firstAvailable.options.slice() : [];

        this.swatchButtons.forEach(function (btn) {
          btn.addEventListener('click', this._onSwatchClick.bind(this));
        }, this);
        this.selects.forEach(function (sel) {
          sel.addEventListener('change', this._onSelectChange.bind(this));
        }, this);

        this._syncControls();
        this._decorateOptions();
        this._update();

        if (this.addBtn) this.addBtn.addEventListener('click', this._onAdd.bind(this));

        var openQuickView = this._onQuickView.bind(this);
        if (this.mediaEl) this.mediaEl.addEventListener('click', openQuickView);
        if (this.titleEl) this.titleEl.addEventListener('click', openQuickView);
      }

      _onQuickView() {
        // leva a família junto: o popup mostra a mesma paleta do card
        getQuickView().open(this.product, window.KB_COLLECTION_HANDLE || '', this.family);
      }

      _colorIdx(product) {
        var names = ((product || this.product) || {}).options || [];
        for (var i = 0; i < names.length; i++) {
          if (/cor|color|colour/i.test(names[i])) return i;
        }
        return -1;
      }

      _memberByHandle(handle) {
        return this.family.filter(function (p) { return p.handle === handle; })[0] || null;
      }

      /* Troca o produto ativo mantendo o que der (tamanho, modelo) — só o que
         existir de verdade na grade do irmão, que pode ser menor (a Cores Novas
         só tem Gola O, a do card tem Gola O e V). */
      _switchProduct(target, colorVal) {
        var prevNames = (this.product.options || []).slice();
        var prevSel = this.selected.slice();

        this.product = target;
        var variants = target.variants || [];
        var first = variants.find(function (v) { return v.available; }) || variants[0];
        this.selected = first ? first.options.slice() : [];

        var ci = this._colorIdx();
        if (ci >= 0) {
          var exact = variants.find(function (v) { return v.options[ci] === colorVal && v.available; }) ||
            variants.find(function (v) { return v.options[ci] === colorVal; });
          if (exact) this.selected = exact.options.slice();
        }

        (target.options || []).forEach(function (name, i) {
          if (i === ci) return;
          var pi = prevNames.indexOf(name);
          if (pi < 0 || prevSel[pi] === undefined) return;
          var candidate = this.selected.slice();
          candidate[i] = prevSel[pi];
          if (matchVariant(this.product, candidate)) this.selected = candidate;
        }, this);

        this._rebuildSelects();
        if (this.titleEl) this.titleEl.textContent = target.title;
      }

      /* A grade do irmão pode ter outros valores de tamanho/modelo, então os
         <select> são remontados a partir do produto ativo. Opção que o irmão
         não tem some junto com o seletor. */
      _rebuildSelects() {
        this.selects.forEach(function (sel) {
          var idx = parseInt(sel.getAttribute('data-option-index'), 10);
          var names = this.product.options || [];
          var wrap = sel.closest('.kit-builder-card__option');
          if (idx >= names.length) {
            if (wrap) wrap.hidden = true;
            return;
          }
          if (wrap) wrap.hidden = false;

          var seen = {}, values = [];
          (this.product.variants || []).forEach(function (v) {
            var val = v.options[idx];
            if (val !== undefined && !(val in seen)) { seen[val] = true; values.push(val); }
          });

          sel.innerHTML = values.map(function (val) {
            return '<option value="' + esc(val) + '" data-label="' + esc(val) + '">' + esc(val) + '</option>';
          }).join('');
        }, this);
      }

      _onSwatchClick(e) {
        var btn = e.currentTarget;
        var idx = parseInt(btn.getAttribute('data-option-index'), 10);
        var val = btn.getAttribute('data-value');

        // cor de outro produto da família: troca o produto ativo por baixo
        var handle = btn.getAttribute('data-product-handle');
        if (handle && handle !== this.product.handle) {
          var target = this._memberByHandle(handle);
          if (target) {
            this._switchProduct(target, val);
            this._syncControls();
            this._decorateOptions();
            this._update();
            return;
          }
        }

        this.selected[idx] = val;
        this._syncControls();
        this._decorateOptions();
        this._update();
      }

      _onSelectChange(e) {
        var idx = parseInt(e.target.getAttribute('data-option-index'), 10);
        this.selected[idx] = e.target.value;
        this._syncControls();
        this._decorateOptions();
        this._update();
      }

      /* Reflete this.selected nos controles (círculos de cor não são radio
         nativo, então o data-selected precisa ser sincronizado manualmente;
         os <select> sincronizam por .value — cobre também o caso de trocar
         a cor mudar a seleção de tamanho quando a combinação atual não
         existir mais). */
      _syncControls() {
        this.swatchButtons.forEach(function (btn) {
          var idx = parseInt(btn.getAttribute('data-option-index'), 10);
          // duas cores da família podem ter o mesmo nome em produtos diferentes:
          // só é a marcada se for também do produto ativo
          var handle = btn.getAttribute('data-product-handle');
          var sameProduct = !handle || handle === this.product.handle;
          var isSelected = sameProduct && this.selected[idx] === btn.getAttribute('data-value');
          btn.setAttribute('data-selected', isSelected ? 'true' : 'false');
        }, this);
        this.selects.forEach(function (sel) {
          var idx = parseInt(sel.getAttribute('data-option-index'), 10);
          if (this.selected[idx] !== undefined) sel.value = this.selected[idx];
        }, this);
      }

      _matchVariant(vals) {
        return matchVariant(this.product, vals);
      }

      /* Tem estoque desse valor NA COMBINAÇÃO ATUAL das outras opções (ex.:
         esse tamanho, NESSA cor já selecionada) — não só "esse valor existe
         disponível em alguma variante, seja qual for a outra opção". Sem
         isso, um tamanho esgotado só naquela cor aparecia como disponível
         (porque existe em outra cor), mesmo mostrando "combinação
         indisponível" ao selecionar. */
      _valueHasStock(i, val) {
        return valueHasStock(this.product, this.selected, i, val);
      }

      _decorateOptions() {
        /* data-out-of-stock (não `disabled`): o círculo continua clicável —
           só assim dá pra clicar numa cor esgotada e ver a foto do produto
           nela, mesmo sem poder comprar naquela combinação. */
        this.swatchButtons.forEach(function (btn) {
          var idx = parseInt(btn.getAttribute('data-option-index'), 10);
          var val = btn.getAttribute('data-value');
          var handle = btn.getAttribute('data-product-handle');
          var hasStock;
          if (handle && handle !== this.product.handle) {
            /* Cor de irmão: a combinação atual (tamanho/modelo) é do produto
               ativo e não vale pra grade dele — a pergunta aqui é só se a cor
               existe disponível em alguma variante do irmão. */
            var owner = this._memberByHandle(handle);
            hasStock = owner ? valueHasStock(owner, [], idx, val) : false;
          } else {
            hasStock = this._valueHasStock(idx, val);
          }
          btn.setAttribute('data-out-of-stock', hasStock ? 'false' : 'true');
        }, this);
        this.selects.forEach(function (sel) {
          var idx = parseInt(sel.getAttribute('data-option-index'), 10);
          Array.prototype.forEach.call(sel.options, function (opt) {
            var hasStock = this._valueHasStock(idx, opt.value);
            opt.disabled = !hasStock;
            var label = opt.getAttribute('data-label') || opt.value;
            opt.textContent = hasStock ? label : label + ' (esgotado)';
          }, this);
        }, this);
      }

      _update() {
        var v = this._matchVariant(this.selected);
        var display = v || bestDisplayVariant(this.product, this.selected);

        if (display && display.featured_image && this.imageEl) this.imageEl.src = display.featured_image;
        if (display) this._renderPrice(display);

        if (this.errorEl) this.errorEl.hidden = !!(v && v.available);

        if (v && v.available) {
          if (this.addBtn) { this.addBtn.disabled = false; this.addBtn.dataset.variantId = v.id; }
        } else {
          if (this.addBtn) { this.addBtn.disabled = true; delete this.addBtn.dataset.variantId; }
        }
      }

      /* Mostra o mesmo par que a vitrine e a PDP mostram: valor cheio
         riscado + valor no Pix em destaque. O card mostrava só o preço
         cheio, então a mesma camiseta parecia mais cara aqui do que na
         coleção normal — e o cliente não via que o valor já é com Pix. */
      _renderPrice(v) {
        var pix = kbPixCents(v.price);
        var full = kbFullCents(v.price, v.compare_at_price);
        if (this.priceNowEl) this.priceNowEl.textContent = brl(pix);
        if (this.priceWasEl) {
          this.priceWasEl.textContent = brl(full);
          this.priceWasEl.hidden = full <= pix;
        }
      }

      _onAdd() {
        var id = this.addBtn && this.addBtn.dataset.variantId;
        if (!id || this.addBtn.disabled) return;
        this.addBtn.disabled = true;
        if (this.addLabel) this.addLabel.textContent = 'Adicionando…';

        var props = {};
        props._dp_source = window.KB_COLLECTION_HANDLE || '';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1, properties: props }] })
        })
          .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); })
          .then(function (added) {
            document.dispatchEvent(new CustomEvent('cart:updated'));
            publishCartUpdate({ source: 'kit-builder', productVariantId: id, cartData: added });
            refreshCartIconBubble();
            if (this.addLabel) this.addLabel.textContent = '✓ Adicionado';
            setTimeout(function () {
              this.addBtn.disabled = false;
              if (this.addLabel) this.addLabel.textContent = '+ Adicionar';
            }.bind(this), 900);
          }.bind(this))
          .catch(function () {
            this.addBtn.disabled = false;
            if (this.addLabel) this.addLabel.textContent = '+ Adicionar';
            if (this.errorEl) this.errorEl.hidden = false;
          }.bind(this));
      }
    }
    customElements.define('kit-product-card', KitProductCardEl);
  }

  /* ================= <kit-quick-view> =================
     Popup ao clicar na foto/título de um card: reaproveita o MESMO JSON de
     produto já embutido no card (assets/kit-builder.js não faz nenhuma
     requisição nova) — só exibe imagem/preço/opções/adicionar numa UI
     maior. Elemento único pra página inteira, criado sob demanda por
     getQuickView() e reaproveitado entre cliques. */
  if (!customElements.get('kit-quick-view')) {
    class KitQuickViewEl extends HTMLElement {
      connectedCallback() {
        this.hidden = true;
        this.innerHTML =
          '<div class="kit-quick-view__backdrop" data-kit-qv-close></div>' +
          '<div class="kit-quick-view__dialog" role="dialog" aria-modal="true">' +
            '<div class="kit-quick-view__header">' +
              '<button type="button" class="kit-quick-view__close" data-kit-qv-close aria-label="Fechar">&times;</button>' +
            '</div>' +
            '<div class="kit-quick-view__body" data-kit-qv-body></div>' +
          '</div>';
        this.bodyEl = this.querySelector('[data-kit-qv-body]');

        this.addEventListener('click', function (e) {
          if (e.target.closest('[data-kit-qv-close]')) this.close();
        }.bind(this));
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !this.hidden) this.close();
        }.bind(this));
      }

      open(product, collectionHandle, family) {
        this.product = product;
        this.family = (family && family.length) ? family : [product];
        var variants = product.variants || [];
        var firstAvailable = variants.find(function (v) { return v.available; }) || variants[0];
        this.selected = firstAvailable ? firstAvailable.options.slice() : [];
        this.collectionHandle = collectionHandle;
        this._render();
        this.hidden = false;
        document.body.classList.add('kit-quick-view-open');
      }

      close() {
        this.hidden = true;
        document.body.classList.remove('kit-quick-view-open');
      }

      /* Troca o produto ativo mantendo tamanho/modelo quando a grade do irmão
         tem, e redesenha: o popup monta o corpo inteiro a partir de
         this.product, então re-render é o caminho natural aqui. */
      _switchProduct(target, colorVal) {
        var prevNames = (this.product.options || []).slice();
        var prevSel = this.selected.slice();

        this.product = target;
        var variants = target.variants || [];
        var first = variants.find(function (v) { return v.available; }) || variants[0];
        this.selected = first ? first.options.slice() : [];

        var ci = (target.options || []).findIndex(function (n) { return /cor|color|colour/i.test(n); });
        if (ci >= 0) {
          var exact = variants.find(function (v) { return v.options[ci] === colorVal && v.available; }) ||
            variants.find(function (v) { return v.options[ci] === colorVal; });
          if (exact) this.selected = exact.options.slice();
        }

        (target.options || []).forEach(function (name, i) {
          if (i === ci) return;
          var pi = prevNames.indexOf(name);
          if (pi < 0 || prevSel[pi] === undefined) return;
          var candidate = this.selected.slice();
          candidate[i] = prevSel[pi];
          if (matchVariant(this.product, candidate)) this.selected = candidate;
        }, this);

        this._render();
      }

      _render() {
        var self = this;
        var product = this.product;
        var v0 = matchVariant(product, this.selected) || bestDisplayVariant(product, this.selected);

        /* Carrossel: usa product.images (todas as fotos), começando na foto
           da variante inicial (v0.image_id) quando existir. Sem product.images
           (produto antigo sem essa lista), cai pra 1 slide só com a foto que
           já tínhamos. */
        var images = (product.images && product.images.length)
          ? product.images
          : (v0 && v0.featured_image ? [{ id: 0, src: v0.featured_image }]
            : (product.featured_image ? [{ id: 0, src: product.featured_image }] : []));
        this.images = images;
        this.activeIndex = 0;
        if (v0 && v0.image_id) {
          var startIdx = images.findIndex(function (img) { return img.id === v0.image_id; });
          if (startIdx >= 0) this.activeIndex = startIdx;
        }

        var optionsHtml = '';
        (product.options || []).forEach(function (name, i) {
          var values = [];
          (product.variants || []).forEach(function (variant) {
            if (values.indexOf(variant.options[i]) === -1) values.push(variant.options[i]);
          });
          var isColor = /cor|color|colour/i.test(name);
          if (isColor) {
            /* A cor atravessa produtos: a paleta é a da família inteira, na
               mesma ordem do card. Cada bolinha carrega de quem ela é. */
            var swatchHtml = (self.family || [product]).map(function (member) {
              var mi = (member.options || []).findIndex(function (n) { return /cor|color|colour/i.test(n); });
              if (mi < 0) return '';
              var seen = {};
              return (member.variants || []).map(function (variant) {
                var val = variant.options[mi];
                if (val === undefined || seen[val]) return '';
                seen[val] = true;
                /* Mesma resolução do card (kit-builder-card.liquid): cor >
                   imagem (textura/estampa) > em branco. member.swatches vem
                   pronto do Liquid, monta 1x por produto. */
                var sw = (member.swatches && member.swatches[val]) || {};
                var style = sw.color
                  ? ' style="background-color: ' + esc(sw.color) + ';"'
                  : (sw.image ? ' style="background-image: url(' + esc(sw.image) + '); background-size: cover;"' : '');
                return '<button type="button" class="product-card-color-swatch__item kit-builder-card__swatch"' + style +
                  ' data-option-index="' + i + '" data-product-handle="' + esc(member.handle || '') + '"' +
                  ' data-value="' + esc(val) + '" aria-label="' + esc(val) + '"></button>';
              }).join('');
            }).join('');

            optionsHtml += '<div class="kit-quick-view__option kit-quick-view__option--color">' +
              '<span class="visually-hidden">' + esc(name) + '</span>' +
              '<div class="product-card-color-swatch">' + swatchHtml +
              '</div></div>';
          } else {
            optionsHtml += '<div class="kit-quick-view__option">' +
              '<label class="form__label">' + esc(name) + '</label>' +
              '<div class="kit-builder-card__select-wrap">' +
              '<select class="kit-builder-card__select" data-option-index="' + i + '">' +
              values.map(function (val) {
                return '<option value="' + esc(val) + '">' + esc(val) + '</option>';
              }).join('') +
              '</select><span class="kit-builder-card__select-arrow" aria-hidden="true"></span>' +
              '</div></div>';
          }
        });

        var slidesHtml = images.map(function (img) {
          return '<div class="kit-quick-view__slide"><img src="' + esc(img.src) + '" alt="" draggable="false"></div>';
        }).join('');

        this.bodyEl.innerHTML =
          '<div class="kit-quick-view__media">' +
            '<div class="kit-quick-view__carousel">' +
              '<div class="kit-quick-view__track" data-kit-qv-track>' + slidesHtml + '</div>' +
            '</div>' +
            (images.length > 1
              ? '<button type="button" class="kit-quick-view__arrow kit-quick-view__arrow--prev" data-kit-qv-prev aria-label="Foto anterior">&lsaquo;</button>' +
                '<button type="button" class="kit-quick-view__arrow kit-quick-view__arrow--next" data-kit-qv-next aria-label="Próxima foto">&rsaquo;</button>' +
                '<div class="kit-quick-view__dots" data-kit-qv-dots>' +
                  images.map(function (_, i) {
                    return '<span class="kit-quick-view__dot" data-kit-qv-dot="' + i + '"></span>';
                  }).join('') +
                '</div>'
              : '') +
          '</div>' +
          '<div class="kit-quick-view__info">' +
            '<h3 class="kit-quick-view__title">' + esc(product.title) + '</h3>' +
            '<div class="kit-quick-view__price">' +
              '<s class="kit-quick-view__price-was" data-kit-qv-price-was hidden></s>' +
              '<span class="kit-quick-view__price-main">' +
                '<span class="kit-quick-view__price-now" data-kit-qv-price></span>' +
                (kbPixPct() > 0 ? '<span class="kit-quick-view__price-note">no Pix</span>' : '') +
              '</span>' +
            '</div>' +
            optionsHtml +
            '<p class="kit-builder-card__error" data-kit-qv-error hidden>Essa combinação está indisponível. Escolha outra.</p>' +
            '<button type="button" class="kit-builder-card__add" data-kit-qv-add>' +
              '<span data-kit-qv-add-label>+ Adicionar</span>' +
            '</button>' +
          '</div>';

        this.swatchButtons = Array.prototype.slice.call(this.bodyEl.querySelectorAll('.kit-builder-card__swatch'));
        this.selects = Array.prototype.slice.call(this.bodyEl.querySelectorAll('.kit-builder-card__select'));
        this.addBtn = this.bodyEl.querySelector('[data-kit-qv-add]');
        this.addLabel = this.bodyEl.querySelector('[data-kit-qv-add-label]');
        this.errorEl = this.bodyEl.querySelector('[data-kit-qv-error]');
        this.priceEl = this.bodyEl.querySelector('[data-kit-qv-price]');
        this.priceWasEl = this.bodyEl.querySelector('[data-kit-qv-price-was]');
        this._setupCarousel();

        this.swatchButtons.forEach(function (btn) {
          btn.addEventListener('click', function () {
            var idx = parseInt(btn.getAttribute('data-option-index'), 10);
            var val = btn.getAttribute('data-value');
            // cor de outro produto da família: troca o produto e redesenha o popup
            var handle = btn.getAttribute('data-product-handle');
            if (handle && handle !== self.product.handle) {
              var target = (self.family || []).filter(function (m) { return m.handle === handle; })[0];
              if (target) { self._switchProduct(target, val); return; }
            }
            self.selected[idx] = val;
            self._syncAndUpdate();
          });
        });
        this.selects.forEach(function (sel) {
          var idx = parseInt(sel.getAttribute('data-option-index'), 10);
          if (self.selected[idx] !== undefined) sel.value = self.selected[idx];
          sel.addEventListener('change', function () {
            self.selected[idx] = sel.value;
            self._syncAndUpdate();
          });
        });
        if (this.addBtn) this.addBtn.addEventListener('click', function () { self._onAdd(); });

        this._syncAndUpdate();
      }

      /* Carrossel sem lib: setas (desktop) + arrastar com Pointer Events
         (cobre touch e mouse com o mesmo código). Troca de slide por
         translateX em %; durante o arraste usa px (mede a largura real do
         carrossel) e volta pra % ao soltar. */
      _setupCarousel() {
        var self = this;
        var track = this.bodyEl.querySelector('[data-kit-qv-track]');
        if (!track) { this._carouselGoTo = null; return; }
        var carouselEl = track.parentElement;
        var prevBtn = this.bodyEl.querySelector('[data-kit-qv-prev]');
        var nextBtn = this.bodyEl.querySelector('[data-kit-qv-next]');
        var dots = Array.prototype.slice.call(this.bodyEl.querySelectorAll('[data-kit-qv-dot]'));

        function goTo(index) {
          var max = self.images.length - 1;
          self.activeIndex = Math.max(0, Math.min(max, index));
          track.style.transition = '';
          track.style.transform = 'translateX(-' + (self.activeIndex * 100) + '%)';
          dots.forEach(function (dot, i) {
            dot.classList.toggle('is-active', i === self.activeIndex);
          });
        }
        this._carouselGoTo = goTo;
        goTo(this.activeIndex);

        if (prevBtn) prevBtn.addEventListener('click', function () { goTo(self.activeIndex - 1); });
        if (nextBtn) nextBtn.addEventListener('click', function () { goTo(self.activeIndex + 1); });
        dots.forEach(function (dot, i) {
          dot.addEventListener('click', function () { goTo(i); });
        });

        var dragging = false;
        var startX = 0;
        var startTranslatePx = 0;

        track.addEventListener('pointerdown', function (e) {
          if (self.images.length <= 1) return;
          dragging = true;
          startX = e.clientX;
          startTranslatePx = -self.activeIndex * carouselEl.offsetWidth;
          track.style.transition = 'none';
          track.setPointerCapture(e.pointerId);
        });
        track.addEventListener('pointermove', function (e) {
          if (!dragging) return;
          track.style.transform = 'translateX(' + (startTranslatePx + (e.clientX - startX)) + 'px)';
        });
        function endDrag(e) {
          if (!dragging) return;
          dragging = false;
          var dx = e.clientX - startX;
          var threshold = carouselEl.offsetWidth * 0.15;
          if (dx > threshold) goTo(self.activeIndex - 1);
          else if (dx < -threshold) goTo(self.activeIndex + 1);
          else goTo(self.activeIndex);
        }
        track.addEventListener('pointerup', endDrag);
        track.addEventListener('pointercancel', endDrag);
      }

      _syncAndUpdate() {
        var self = this;
        this.swatchButtons.forEach(function (btn) {
          var idx = parseInt(btn.getAttribute('data-option-index'), 10);
          var val = btn.getAttribute('data-value');
          var handle = btn.getAttribute('data-product-handle');
          var foreign = handle && handle !== self.product.handle;
          btn.setAttribute('data-selected', (!foreign && self.selected[idx] === val) ? 'true' : 'false');
          // cor de irmão: a combinação atual é do produto ativo e não vale
          // pra grade dele — pergunta só se a cor existe disponível lá
          var owner = foreign
            ? (self.family || []).filter(function (m) { return m.handle === handle; })[0]
            : self.product;
          var hasStock = owner ? valueHasStock(owner, foreign ? [] : self.selected, idx, val) : false;
          btn.setAttribute('data-out-of-stock', hasStock ? 'false' : 'true');
        });
        this.selects.forEach(function (sel) {
          var idx = parseInt(sel.getAttribute('data-option-index'), 10);
          if (self.selected[idx] !== undefined) sel.value = self.selected[idx];
          Array.prototype.forEach.call(sel.options, function (opt) {
            opt.disabled = !valueHasStock(self.product, self.selected, idx, opt.value);
          });
        });

        var v = matchVariant(this.product, this.selected);
        var display = v || bestDisplayVariant(this.product, this.selected);
        if (display && display.image_id && this.images && this._carouselGoTo) {
          var idx = this.images.findIndex(function (img) { return img.id === display.image_id; });
          if (idx >= 0) this._carouselGoTo(idx);
        }
        /* Mesmo par do card e da vitrine: cheio riscado + valor no Pix. */
        if (display && this.priceEl) {
          var pix = kbPixCents(display.price);
          var full = kbFullCents(display.price, display.compare_at_price);
          this.priceEl.textContent = brl(pix);
          if (this.priceWasEl) {
            this.priceWasEl.textContent = brl(full);
            this.priceWasEl.hidden = full <= pix;
          }
        }
        if (this.errorEl) this.errorEl.hidden = !!(v && v.available);
        if (this.addBtn) this.addBtn.disabled = !(v && v.available);
      }

      _onAdd() {
        var v = matchVariant(this.product, this.selected);
        if (!v || !v.available) return;
        var self = this;
        this.addBtn.disabled = true;
        if (this.addLabel) this.addLabel.textContent = 'Adicionando…';

        var props = {};
        props._dp_source = this.collectionHandle || '';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: props }] })
        })
          .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); })
          .then(function (added) {
            document.dispatchEvent(new CustomEvent('cart:updated'));
            publishCartUpdate({ source: 'kit-builder', productVariantId: v.id, cartData: added });
            refreshCartIconBubble();
            if (self.addLabel) self.addLabel.textContent = '✓ Adicionado';
            setTimeout(function () { self.close(); }, 700);
          })
          .catch(function () {
            self.addBtn.disabled = false;
            if (self.addLabel) self.addLabel.textContent = '+ Adicionar';
            if (self.errorEl) self.errorEl.hidden = false;
          });
      }
    }
    customElements.define('kit-quick-view', KitQuickViewEl);
  }

  /* ================= <kit-builder-sidebar> ================= */
  if (!customElements.get('kit-builder-sidebar')) {
    class KitBuilderSidebarEl extends HTMLElement {
      connectedCallback() {
        this.countEl = this.querySelector('[data-kit-count]');
        this.pillEl = this.querySelector('[data-kit-pill]');
        this.encourageEl = this.querySelector('[data-kit-encourage]');
        this.listEl = this.querySelector('[data-kit-list]');
        this.totalsEl = this.querySelector('[data-kit-totals]');
        this.subtotalEl = this.querySelector('[data-kit-subtotal]');
        this.totalPixEl = this.querySelector('[data-kit-total-pix]');
        this.rowPromoEl = this.querySelector('[data-kit-row-promo]');
        this.promoValueEl = this.querySelector('[data-kit-promo-value]');
        this.rowKitEl = this.querySelector('[data-kit-row-kit]');
        this.kitLabelEl = this.querySelector('[data-kit-kit-label]');
        this.kitValueEl = this.querySelector('[data-kit-kit-value]');
        this.rowPixEl = this.querySelector('[data-kit-row-pix]');
        this.pixValueEl = this.querySelector('[data-kit-pix-value]');
        this.checkoutEl = this.querySelector('[data-kit-checkout]');
        this.foreignEl = this.querySelector('[data-kit-foreign]');
        this.foreignKeys = [];
        this.toggleEl = this.querySelector('[data-kit-toggle]');
        this.headerEl = this.querySelector('.kit-builder-sidebar__header');

        this.collectionHandle = window.KB_COLLECTION_HANDLE || '';
        this.pix = parseFloat(window.KB_PIX_DISCOUNT || 0) || 0;
        this.tiers = this._loadTiers();
        this.variantMeta = this._buildVariantMeta();
        this._lastPieces = null;

        this._fetchAndRender = this._fetchAndRender.bind(this);
        this._refresh = debounce(this._fetchAndRender, 150);

        if (this.checkoutEl) {
          this.checkoutEl.addEventListener('click', this._onCheckout.bind(this));
        }

        /* Só existe (visualmente) no mobile: alterna a lista de peças
           entre recolhida (só o resumo flutuante) e expandida. A faixa
           INTEIRA (contador + pílula + seta) é clicável, não só a seta —
           mais fácil de acertar o toque. Um listener só no header (não
           mais um segundo na seta) evita disparar duas vezes no mesmo
           clique por causa do bubbling. */
        if (this.headerEl) {
          this.headerEl.addEventListener('click', function () {
            var expanded = this.classList.toggle('is-expanded');
            if (this.toggleEl) this.toggleEl.setAttribute('aria-expanded', expanded ? 'true' : 'false');
            /* O elemento POSICIONADO no mobile é o <aside> em volta, não este
               custom element — é ele que precisa esticar de um menu ao outro
               quando abre. Marcar os dois evita depender de `:has()`. */
            var wrap = this.closest('.kit-builder__sidebar');
            if (wrap) wrap.classList.toggle('is-open', expanded);
          }.bind(this));
        }

        this._setupScrollTrap();

        document.addEventListener('cart:updated', this._refresh);
        document.addEventListener('cart:refresh', this._refresh);
        if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
          subscribe(PUB_SUB_EVENTS.cartUpdate, this._refresh);
        }
        window.addEventListener('pageshow', function (e) { if (e.persisted) this._fetchAndRender(); }.bind(this));

        this._fetchAndRender();
      }

      /* No mobile o card é fixo/flutuante por cima da página — tocar em
         qualquer parte dele que NÃO seja a lista rolável (header, título,
         texto de incentivo, subtotal/totais, botão) e arrastar movia a
         PÁGINA atrás, porque essas áreas não têm scroll próprio pra
         "segurar" o gesto. Bloqueia touchmove/wheel que começam fora da
         lista; dentro da lista deixa nativo (overscroll-behavior no CSS
         cuida de não vazar quando a lista chega no topo/fim). Só no
         breakpoint onde o card é flutuante — no desktop a sidebar é
         sticky, faz parte do fluxo normal da página. */
      _setupScrollTrap() {
        var self = this;
        var mobileQuery = window.matchMedia('(max-width: 989px)');
        function startsInsideList(target) {
          return self.listEl && (target === self.listEl || self.listEl.contains(target));
        }
        function guard(e) {
          if (!mobileQuery.matches) return;
          if (startsInsideList(e.target)) return;
          e.preventDefault();
        }
        this.addEventListener('touchmove', guard, { passive: false });
        this.addEventListener('wheel', guard, { passive: false });
      }

      _loadTiers() {
        var cfg = {};
        try {
          var raw = document.getElementById('kb-tiers-config');
          if (raw) cfg = JSON.parse(raw.textContent);
        } catch (e) { cfg = {}; }
        return (cfg.tiers || []).slice().sort(function (a, b) { return a.minQuantity - b.minQuantity; });
      }

      /* Preço cheio/foto por variante, lidos do JSON que cada card embute.
         O JSON virou `{ family: [produto, irmão de cor, ...] }` quando o
         card passou a mostrar a paleta inteira da família, e este mapa
         continuou lendo `data.variants` da raiz — que não existe mais.
         Resultado: o mapa ficava VAZIO e o riscado caía sempre no preço
         normal, ignorando compare_at (produto em promoção aparecia sem a
         promoção). Lê os dois formatos. */
      _buildVariantMeta() {
        var meta = {};
        document.querySelectorAll('kit-product-card [data-kit-product]').forEach(function (el) {
          var data;
          try { data = JSON.parse(el.textContent); } catch (e) { return; }
          var products = (data.family && data.family.length) ? data.family : [data];
          products.forEach(function (product) {
            (product.variants || []).forEach(function (v) {
              meta[v.id] = {
                compare_at_price: v.compare_at_price || 0,
                price: v.price,
                title: product.title,
                image: v.featured_image || product.featured_image
              };
            });
          });
        });
        return meta;
      }

      /* Valores de UMA linha, mirando a faixa que o KIT SOZINHO alcança.
         - full: valor cheio (compare_at quando o produto está em promoção)
         - original: o que a Shopify cobraria sem os descontos do carrinho
         - final: com a faixa do kit — é o que o checkout vai cobrar
         - pix: final menos o % do Pix, o número em destaque na tela

         Por que não ler direto o desconto que está no carrinho: a faixa conta
         TODA peça da coleção que esteja lá, inclusive as que a pessoa
         adicionou em outra página. Quem tinha 2 camisetas no carrinho do site
         e adicionava 1 aqui via 10% no card — mas o "Finalizar" leva só o kit,
         então o checkout cobraria 1 peça sem desconto nenhum. O card prometia
         um desconto que não era dele.

         @param it linha do /cart.js
         @param pctDoKit % da faixa que as peças DESTA página alcançam
         @param algumaComDesconto alguma linha do kit recebeu faixa agora? */
      _lineMoney(it, pctDoKit, algumaComDesconto) {
        var meta = this.variantMeta[it.variant_id] || {};
        var qty = it.quantity || 0;
        var original = it.original_line_price != null ? it.original_line_price : (it.price || 0) * qty;
        var compareAt = meta.compare_at_price > 0 ? meta.compare_at_price * qty : 0;
        var doCarrinho = it.final_line_price != null ? it.final_line_price : original;
        var aplicado = linePercentOff(it, original, doCarrinho);

        var pct = pctDoKit || 0;
        var final;
        if (aplicado <= 0 && algumaComDesconto) {
          /* A Function deixou ESTA linha de fora (outlet, variante marcada) —
             não promete desconto que o checkout não vai dar. */
          pct = 0;
          final = original;
        } else if (Math.abs(aplicado - pct) < 0.01) {
          /* Carrinho já está na faixa do kit: usa o valor REAL da linha, sem
             risco de diferença de centavo com o checkout. */
          final = doCarrinho;
        } else {
          final = precoComFaixa(original, qty, pct);
        }

        var full = Math.max(compareAt, original);
        var pix = kbPixCents(final);
        return {
          full: full,
          original: original,
          final: final,
          pix: pix,
          tierPct: pct,
          offPct: full > 0 ? Math.round((1 - pix / full) * 100) : 0
        };
      }

      _fetchAndRender() {
        var self = this;
        fetch('/cart.js?ts=' + Date.now(), { headers: { Accept: 'application/json' }, cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .then(function (cart) { self._render(cart); })
          .catch(function () { /* mantém o estado atual em caso de falha */ });
      }

      _render(cart) {
        var self = this;
        var items = (cart.items || []).filter(function (it) {
          return it.properties && it.properties._dp_source === self.collectionHandle;
        });

        /* Peças que estão no carrinho do site e NÃO foram montadas aqui. Elas
           não entram na conta do kit (nunca entraram) e agora também não vão
           junto no "Finalizar compra": esta compra é só do kit. */
        var foreign = (cart.items || []).filter(function (it) {
          return !(it.properties && it.properties._dp_source === self.collectionHandle);
        });
        this.foreignKeys = foreign.map(function (it) { return it.key; });

        var pieces = items.reduce(function (sum, it) { return sum + (it.quantity || 0); }, 0);
        if (this.countEl) {
          var piecesChanged = this._lastPieces !== undefined && this._lastPieces !== null && pieces !== this._lastPieces;
          this.countEl.textContent = String(pieces);
          if (piecesChanged) {
            this.countEl.classList.remove('kit-builder-sidebar__count-number--pulse');
            void this.countEl.offsetWidth; /* força reflow pra reiniciar a animação */
            this.countEl.classList.add('kit-builder-sidebar__count-number--pulse');
          }
        }
        this._lastPieces = pieces;

        /* A faixa que as peças DESTA página alcançam sozinhas — é a que o
           checkout vai aplicar, já que o "Finalizar" leva só o kit. Mesma
           fonte da pílula e da mensagem de incentivo, então o card inteiro
           passa a falar o mesmo número. */
        var tierDoKit = this._currentTier(pieces);
        var pctDoKit = tierDoKit ? tierDoKit.percentage : 0;
        var algumaComDesconto = items.some(function (it) { return linePercentOff(it, 0, 0) > 0; });

        var fullCents = 0;
        var originalCents = 0;
        var finalCents = 0;
        items.forEach(function (it) {
          var money = self._lineMoney(it, pctDoKit, algumaComDesconto);
          fullCents += money.full;
          originalCents += money.original;
          finalCents += money.final;
        });

        var totalPixCents = kbPixCents(finalCents);
        /* Cada desconto na sua linha, em vez de uma diferença solta entre
           subtotal e total: promoção do produto, faixa do kit e Pix. */
        var promoCents = Math.max(fullCents - originalCents, 0);
        var kitCents = Math.max(originalCents - finalCents, 0);
        var pixCents = Math.max(finalCents - totalPixCents, 0);

        if (items.length > 0) {
          if (this.totalsEl) this.totalsEl.hidden = false;
          if (this.subtotalEl) this.subtotalEl.textContent = brl(fullCents);
          this._renderDiscountRow(this.rowPromoEl, this.promoValueEl, promoCents);
          if (this.kitLabelEl) {
            this.kitLabelEl.textContent = pctDoKit > 0
              ? ('Desconto do kit (' + pctLabel(pctDoKit) + ')')
              : 'Desconto do kit';
          }
          this._renderDiscountRow(this.rowKitEl, this.kitValueEl, kitCents);
          this._renderDiscountRow(this.rowPixEl, this.pixValueEl, pixCents);
          if (this.totalPixEl) this.totalPixEl.textContent = brl(totalPixCents);
          if (this.checkoutEl) this.checkoutEl.removeAttribute('disabled');
        } else {
          this._resetTotals();
          if (this.checkoutEl) this.checkoutEl.setAttribute('disabled', 'disabled');
        }

        this._renderForeignNotice(foreign);

        this._renderList(items, pctDoKit, algumaComDesconto);
        this._renderPill(pieces);
        this._renderEncouragement(pieces);
      }

      /* Aviso, ANTES do clique, de que o carrinho do site tem peça que não é
         do kit e que ela vai sair. Escondido quando não há nenhuma.
         Não precisa falar de desconto: os números do card já são os do kit
         sozinho, que é o que o checkout vai cobrar. */
      _renderForeignNotice(foreign) {
        if (!this.foreignEl) return;
        var units = foreign.reduce(function (sum, it) { return sum + (it.quantity || 0); }, 0);
        this.foreignEl.hidden = units <= 0;
        this.foreignEl.textContent = units <= 0
          ? ''
          : (units === 1
            ? 'Finalizar leva só o kit — 1 item de fora sai do carrinho.'
            : 'Finalizar leva só o kit — ' + units + ' itens de fora saem do carrinho.');
      }

      /* O checkout desta página é SÓ do kit: o que a pessoa tinha no carrinho
         do site (de outra página, de outra visita) sai antes de ir pro
         checkout. Sem isso o cliente montava um kit e pagava junto uma peça
         que nem lembrava ter deixado lá.

         Uma chamada só (`/cart/update.js` aceita um mapa de chaves de linha) e
         por CHAVE, não por variant id — a mesma variante pode estar em duas
         linhas, uma do kit e outra de fora, e só a de fora pode sair.

         Fail-safe: se a limpeza falhar, segue pro checkout assim mesmo. Travar
         a compra por causa disso seria pior que levar um item a mais. */
      _onCheckout(e) {
        if (this.checkoutEl.hasAttribute('disabled')) {
          e.preventDefault();
          return;
        }
        if (!this.foreignKeys.length) return;

        e.preventDefault();
        var destino = this.checkoutEl.getAttribute('href');
        var updates = {};
        this.foreignKeys.forEach(function (key) { updates[key] = 0; });
        var segue = function () { window.location.href = destino; };

        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        })
          .then(segue)
          .catch(segue);
      }

      _renderDiscountRow(rowEl, valueEl, cents) {
        if (!rowEl) return;
        rowEl.hidden = cents <= 0;
        if (valueEl) valueEl.textContent = cents > 0 ? ('\u2212 ' + brl(cents)) : '';
      }

      /* Esvaziar o kit não pode deixar número velho na tela. Esconder o
         bloco não bastava: `.kit-builder-sidebar__totals` tem `display:flex`
         no CSS do tema e estilo de autor ganha do `[hidden]` do navegador,
         então o bloco continuava visível — com o total da ÚLTIMA peça
         removida. O CSS agora trata `[hidden]`, e aqui zeramos os valores
         pra nenhum caminho de render reaproveitar sobra. */
      _resetTotals() {
        if (this.totalsEl) this.totalsEl.hidden = true;
        if (this.subtotalEl) this.subtotalEl.textContent = brl(0);
        if (this.totalPixEl) this.totalPixEl.textContent = brl(0);
        this._renderDiscountRow(this.rowPromoEl, this.promoValueEl, 0);
        this._renderDiscountRow(this.rowKitEl, this.kitValueEl, 0);
        this._renderDiscountRow(this.rowPixEl, this.pixValueEl, 0);
      }

      /* Faixa mais alta já desbloqueada com a contagem atual de peças, ou
         null se nenhuma faixa foi atingida ainda. */
      _currentTier(pieces) {
        var current = null;
        for (var i = 0; i < this.tiers.length; i++) {
          if (pieces >= this.tiers[i].minQuantity) current = this.tiers[i];
        }
        return current;
      }

      _renderPill(pieces) {
        if (!this.pillEl) return;
        var current = this._currentTier(pieces);
        /* "Economize 10%" lia como promessa de algo que a pessoa ainda vai
           fazer, quando o desconto JÁ está no carrinho. */
        this.pillEl.textContent = current
          ? 'Economizando ' + pctLabel(current.percentage)
          : 'Sem desconto ainda';
      }

      _renderList(items, pctDoKit, algumaComDesconto) {
        if (!this.listEl) return;
        var self = this;

        if (items.length === 0) {
          this.listEl.innerHTML = '';
          return;
        }

        this.listEl.innerHTML = items.map(function (it) {
          var meta = self.variantMeta[it.variant_id] || {};
          var img = meta.image || it.image || '';
          return (
            '<li class="kit-builder-sidebar__item" data-kit-item="' + esc(it.key) + '">' +
              (img ? '<img class="kit-builder-sidebar__item-image" src="' + esc(img) + '" alt="" width="52" height="52" loading="lazy">' : '') +
              '<div class="kit-builder-sidebar__item-info">' +
                '<div class="kit-builder-sidebar__item-row-top">' +
                  '<p class="kit-builder-sidebar__item-title">' + esc(it.product_title) + '</p>' +
                  '<button type="button" class="kit-builder-sidebar__item-remove" data-kit-remove aria-label="Remover">&times;</button>' +
                '</div>' +
                (it.variant_title ? '<p class="kit-builder-sidebar__item-variant">' + esc(it.variant_title) + '</p>' : '') +
                '<div class="kit-builder-sidebar__item-row-bottom">' +
                  '<div class="kit-builder-sidebar__item-qty">' +
                    '<button type="button" class="kit-builder-sidebar__qty-btn" data-kit-qty-minus aria-label="Diminuir quantidade">&minus;</button>' +
                    '<span data-kit-qty-value>' + it.quantity + '</span>' +
                    '<button type="button" class="kit-builder-sidebar__qty-btn" data-kit-qty-plus aria-label="Aumentar quantidade">+</button>' +
                  '</div>' +
                  self._itemPriceHtml(it, pctDoKit, algumaComDesconto) +
                '</div>' +
              '</div>' +
            '</li>'
          );
        }).join('');

        this.listEl.querySelectorAll('[data-kit-item]').forEach(function (li) {
          var key = li.getAttribute('data-kit-item');
          var item = items.find(function (it) { return it.key === key; });
          if (!item) return;
          var plusBtn = li.querySelector('[data-kit-qty-plus]');
          var minusBtn = li.querySelector('[data-kit-qty-minus]');
          var removeBtn = li.querySelector('[data-kit-remove]');
          if (plusBtn) plusBtn.addEventListener('click', function () { self._changeQty(key, item.quantity + 1); });
          if (minusBtn) minusBtn.addEventListener('click', function () { self._changeQty(key, item.quantity - 1); });
          if (removeBtn) removeBtn.addEventListener('click', function () { self._changeQty(key, 0); });
        });
      }

      /* Preço da peça na régua do resto da loja: valor cheio riscado, o
         quanto sai de desconto ali e o valor no Pix em destaque. Antes a
         linha mostrava só o valor já com faixa, sem riscado e sem dizer
         que ainda faltava o Pix — o cliente comparava com a vitrine e os
         números não batiam. */
      /* Um selo por desconto, cada um na linha do valor que ele explica: a
         faixa do kit ao lado do valor cheio riscado, o Pix ao lado do valor
         no Pix. Antes os dois vinham juntos num selo só ("16% + 3%"), o que
         obrigava a pessoa a descobrir sozinha qual parte era qual. Promoção
         do produto não ganha selo: ela já está dita pelo riscado. */
      _badgeHtml(pct, extraClass) {
        if (!(pct > 0)) return '';
        var cls = 'kit-builder-sidebar__item-price-off' + (extraClass ? ' ' + extraClass : '');
        return '<span class="' + cls + '">-' + pctLabel(pct) + '</span>';
      }

      _itemPriceHtml(it, pctDoKit, algumaComDesconto) {
        var money = this._lineMoney(it, pctDoKit, algumaComDesconto);
        var showWas = money.full > money.pix;
        var note = kbPixPct() > 0
          ? ' <small class="kit-builder-sidebar__item-price-note">no Pix</small>'
          : '';
        return (
          '<span class="kit-builder-sidebar__item-price">' +
            (showWas
              ? '<span class="kit-builder-sidebar__item-price-top">' +
                  '<s class="kit-builder-sidebar__item-price-was">' + brl(money.full) + '</s>' +
                  this._badgeHtml(money.tierPct) +
                '</span>'
              : '') +
            '<span class="kit-builder-sidebar__item-price-bottom">' +
              '<span class="kit-builder-sidebar__item-price-now">' + brl(money.pix) + note + '</span>' +
              this._badgeHtml(kbPixPct(), 'kit-builder-sidebar__item-price-off--pix') +
            '</span>' +
          '</span>'
        );
      }

      _changeQty(key, qty) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: Math.max(qty, 0) })
        })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.dispatchEvent(new CustomEvent('cart:updated'));
            publishCartUpdate({ source: 'kit-builder', cartData: cart });
            refreshCartIconBubble();
          })
          .catch(function () {});
      }

      _renderEncouragement(pieces) {
        if (!this.encourageEl) return;
        if (!this.tiers.length) {
          this.encourageEl.textContent = '';
          return;
        }

        var current = this._currentTier(pieces);
        var next = null;
        for (var j = 0; j < this.tiers.length; j++) {
          if (this.tiers[j].minQuantity > pieces) { next = this.tiers[j]; break; }
        }
        var first = this.tiers[0];
        var last = this.tiers[this.tiers.length - 1];

        /* O que falta pra próxima faixa é o motivo de a pessoa continuar
           montando o kit — era um texto cinza de 1,2rem com opacidade,
           mais discreto que o resto do card. Vira um aviso destacado, com
           a quantidade que falta e o % alvo em negrito na cor de destaque,
           e uma piscada curta toda vez que a mensagem muda. */
        var msg;
        var state = 'urgent';
        if (!current) {
          if (pieces <= 0) {
            msg = 'Adicione produtos pra começar a montar seu kit.';
            state = 'empty';
          } else {
            msg = this._unlockMsg(first.minQuantity - pieces, first.percentage, first === last);
          }
        } else if (!next) {
          /* ✓ dentro do <strong> pra não sobrar sozinho na linha de baixo. */
          msg = 'Desconto máximo desbloqueado: <strong>' + esc(current.percentage) + '% OFF ✓</strong>';
          state = 'max';
        } else {
          msg = this._unlockMsg(next.minQuantity - pieces, next.percentage, next === last);
        }

        var changed = this.encourageEl.innerHTML !== msg;
        this.encourageEl.innerHTML = msg;
        this.encourageEl.classList.toggle('kit-builder-sidebar__encourage--urgent', state === 'urgent');
        this.encourageEl.classList.toggle('kit-builder-sidebar__encourage--max', state === 'max');
        if (changed && state !== 'empty') {
          this.encourageEl.classList.remove('kit-builder-sidebar__encourage--bump');
          void this.encourageEl.offsetWidth; /* força reflow pra reiniciar a animação */
          this.encourageEl.classList.add('kit-builder-sidebar__encourage--bump');
        }
      }

      _unlockMsg(need, percentage, isMax) {
        var pecas = need === 1 ? '1 peça' : need + ' peças';
        var verbo = need === 1 ? 'Falta' : 'Faltam';
        var alvo = isMax
          ? ('o máximo de ' + esc(percentage) + '% OFF')
          : (esc(percentage) + '% OFF');
        return verbo + ' <strong>' + pecas + '</strong> pra desbloquear <strong>' + alvo + '</strong>';
      }
    }
    customElements.define('kit-builder-sidebar', KitBuilderSidebarEl);
  }
})();
